import type * as PIXI from 'pixi.js';

/**
 * "Pick up" animation: the marker's logical position has just jumped by (dx, dy);
 * show it at the old spot and glide it to the new one. Done through the pivot
 * (visual = position − pivot, so pivot = (dx, dy) shows it where it was), which
 * nothing else in the room touches, so the drag can keep moving the position
 * meanwhile without fighting the animation.
 */
export function tweenFromOffset(marker: PIXI.Container, dx: number, dy: number, ms: number): void {
  if (dx === 0 && dy === 0) return;
  const start = performance.now();
  const step = (now: number) => {
    if (marker.destroyed) return;
    const t = Math.min(1, (now - start) / ms);
    const k = 1 - (1 - t) * (1 - t) * (1 - t); // ease-out cubic
    marker.pivot.set(dx * (1 - k), dy * (1 - k));
    if (t < 1) requestAnimationFrame(step);
  };
  marker.pivot.set(dx, dy);
  requestAnimationFrame(step);
}
